// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ArchitectureRouteImport } from './routes/architecture'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as StoresStoreSlugRouteImport } from './routes/stores/$storeSlug'
import { Route as DocsSplatRouteImport } from './routes/docs/$'

const ArchitectureRoute = ArchitectureRouteImport.update({
            id: '/architecture',path: '/architecture',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsersUserIdRoute = UsersUserIdRouteImport.update({
            id: '/users/$userId',path: '/users/$userId',getParentRoute: () => rootRouteImport
          })
const StoresStoreSlugRoute = StoresStoreSlugRouteImport.update({
            id: '/stores/$storeSlug',path: '/stores/$storeSlug',getParentRoute: () => rootRouteImport
          })
const DocsSplatRoute = DocsSplatRouteImport.update({
            id: '/docs/$',path: '/docs/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ArchitectureRoute: ArchitectureRoute,DocsSplatRoute: DocsSplatRoute,StoresStoreSlugRoute: StoresStoreSlugRoute,UsersUserIdRoute: UsersUserIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)